import { currentRefinements } from 'instantsearch.js/es/widgets';
import { currentRefinementsClasses } from './common.js';

export function createCurrentRefinements(
  containerSelector = '[data-current-refinements]',
) {
  const container = document.querySelector(containerSelector);

  if (!container) {
    return null;
  }

  return currentRefinements({
    container,
    cssClasses: {
      root: currentRefinementsClasses.root.join(' '),
      list: currentRefinementsClasses.list.join(' '),
      item: currentRefinementsClasses.item.join(' '),
      label: currentRefinementsClasses.label.join(' '),
      category: currentRefinementsClasses.category.join(' '),
      delete: currentRefinementsClasses.delete.join(' '),
    },
    transformItems(items) {
      return items.map((item) => ({
        ...item,
        label: formatLabel(item.label),
      }));
    },
  });
}

function formatLabel(label) {
  return label
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
}
